<template>
  <a v-if="isExternal" :href="to" v-bind="$attrs">
    <slot/>
  </a>
  <router-link v-else :to="to" v-bind="$attrs">
    <slot/>
  </router-link>
</template>

<script>
import { PREVIEW_PATH } from 'brave-build/constants'

export default {
  props: {
    to: String,
    isExternal: Boolean,
  },
  data() {
    let props = { ...this.$attrs }
    let detectUrl = new RegExp(/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi);


    if (this.isExternal) {
      props.href = this.to || props.href
      delete props.to
    } else if (this.to && this.$route.matched[0].path.indexOf(PREVIEW_PATH) >= 0) {
      let basePreviewPath = PREVIEW_PATH.replace(':build_identifier', this.$route.params.build_identifier)
      props.to = `${basePreviewPath}/${this.to}`
    }

    return {
      props,
    }
  }
}
</script>



// WEBPACK FOOTER //
// lib/brave-routing/components/brave-link.vue